/**
 * Format number as Thai currency (THB)
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format Thai phone number
 * Converts 0812345678 to 081-234-5678
 */
export function formatPhoneNumber(phone: string): string {
  if (!phone) return '';
  
  // Remove all non-digits
  const cleaned = phone.replace(/\D/g, '');
  
  // Format as XXX-XXX-XXXX or XX-XXX-XXXX
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length === 9) {
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 5)}-${cleaned.slice(5)}`;
  }
  
  return phone;
}

/**
 * Format percentage
 */
export function formatPercent(value: number, decimals: number = 2): string {
  return `${value.toFixed(decimals)}%`;
}

/**
 * Format member ID for display
 * Shows first 8 characters with ellipsis
 */
export function formatMemberId(id: string): string {
  if (!id) return '';
  if (id.length <= 8) return id;
  return `${id.slice(0, 8)}...`;
}

/**
 * Format number with Thai locale
 */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat('th-TH').format(value);
}

/**
 * Format date to Buddhist Era (พ.ศ.)
 * Adds 543 years to the Gregorian year
 */
export function formatBuddhistYear(date: Date): string {
  const year = date.getFullYear() + 543;
  return year.toString();
}

/**
 * Convert number to Thai numerals
 */
export function toThaiNumerals(num: number | string): string {
  const thaiNumerals = ['๐', '๑', '๒', '๓', '๔', '๕', '๖', '๗', '๘', '๙'];
  return num.toString().replace(/\d/g, (digit) => thaiNumerals[parseInt(digit)]);
}